import { captureMarketing } from "./analytics.js"
import { marketingContext } from "./marketing_attribution.js"

export default function setupContactForm({ doc = document, capture = captureMarketing,
  attribution = marketingContext, fetcher = (...args) => fetch(...args),
  challenge = () => new window.Botpoison({ publicKey: "pk_29d5c83d-878b-4b62-a672-6d9cf6d55be4" }).challenge(),
  formData = form => new FormData(form), makeId = () => crypto.randomUUID() } = {}) {
  const form = doc.getElementById("contact-form")
  if (!form || form.dataset.initialized) return
  form.dataset.initialized = "true"
  const done = doc.getElementById("contact-form-done")
  const fail = doc.getElementById("contact-form-fail")
  const button = form.querySelector('button[type="submit"]')
  const labelDefault = button.querySelector("[data-label-default]")
  const labelSending = button.querySelector("[data-label-sending]")
  let submitting = false, accepted = false, inquiryId, started = false
  const track = (event, fields = {}) => {
    try { capture(event, { ...attribution(), ...fields }) } catch { /* Never interrupt the form. */ }
  }
  const start = () => {
    if (!started) { started = true; track("contact_form_started") }
  }
  form.addEventListener("input", start)
  form.addEventListener("change", start)
  form.addEventListener("submit", async event => {
    event.preventDefault()
    if (submitting || accepted || !form.reportValidity()) return
    submitting = true
    fail.classList.add("hidden")
    button.disabled = true
    labelDefault.classList.add("hidden")
    labelSending.classList.remove("hidden")
    let failure = "challenge"
    try {
      // IDs aid reconciliation; neither the browser nor Formspark promises deduplication.
      try { inquiryId ||= makeId() } catch { /* A missing ID must not block delivery. */ }
      const fields = inquiryId ? { inquiry_id: inquiryId } : {}
      track("contact_submit_attempted", fields)
      const payload = {}
      for (const [key, value] of formData(form).entries()) {
        if (key === "_email.subject") payload._email = { subject: value }
        else payload[key] = value
      }
      Object.assign(payload, attribution(), fields, { source: "marketing" })
      const { solution } = await challenge()
      payload._botpoison = solution
      failure = "network"
      const response = await fetcher(form.action, {
        method: "POST", body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json", Accept: "application/json" },
      })
      if (!response.ok) { failure = "http"; throw new Error("Provider rejected submission") }
      accepted = true
      form.classList.add("hidden")
      done.classList.remove("hidden")
      done.focus()
      track("contact_submit_accepted", fields)
    } catch {
      track("contact_submit_failed", { ...(inquiryId ? { inquiry_id: inquiryId } : {}), failure_category: failure })
      fail.classList.remove("hidden")
      fail.focus()
    } finally {
      submitting = false
      button.disabled = false
      labelDefault.classList.remove("hidden")
      labelSending.classList.add("hidden")
    }
  })
}
